import { createFileRoute } from '@tanstack/react-router';
import BaseView from 'containers/Base/BaseView';
import { baseModuleConfigs } from 'containers/Base/baseModuleConfigs';
import { prefetchGridSchema } from '../-utils/loaders';

export const Route = createFileRoute('/_authenticated/employees')({
  loader: ({ context }) =>
    prefetchGridSchema(context.queryClient, baseModuleConfigs.Employees.itemType),
  component: () => <BaseView configuration={baseModuleConfigs.Employees} />,
});
